// extracted by mini-css-extract-plugin
export default {"tooltip":"io-z","sharingV2":"jo-z","sharingIconsV2":"ko-z","links":"lo-z","link":"mo-z","facebookV2":"no-z","twitterV2":"oo-z","pinterestV2":"po-z"};